import React, { useState } from "react";
import cn from "classnames";
import onClickOutside from "react-onclickoutside";

const Subscribes = () => {
  const [isOpen, setIsOpen] = useState(false);
  Subscribes.handleClickOutside = () => setIsOpen(false);

  const renderSubscriptionsWindow = () => {
    return (
      <div className="header__subscribes-container">
        <a
          href="https://www.rt.ru/lc/elementary"
          className="header__subscribes-item"
          target="_blank"
        >
          Для 1-4 классов
        </a>
        <a
          href="https://www.rt.ru/lc/middle"
          className="header__subscribes-item"
          target="_blank"
        >
          Для 5-8 классов
        </a>
        <a
          href="https://www.rt.ru/lc/high"
          className="header__subscribes-item"
          target="_blank"
        >
          Для 9-11 классов
        </a>
      </div>
    );
  };

  return (
    <div
      className={cn("header__subscribes-wr", {
        "subscription-opened": isOpen,
      })}
      onClick={() => setIsOpen(!isOpen)}
    >
      Подписки
      {isOpen && renderSubscriptionsWindow()}
    </div>
  );
};

const clickOutsideConfig = {
  handleClickOutside: () => Subscribes.handleClickOutside,
};

export default onClickOutside(Subscribes, clickOutsideConfig);



// WEBPACK FOOTER //
// ./app/frontend/components/Subscribes.js